import React, { } from "react";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
import { GlobalData } from "../util/GlobalData";
import { useTranslation } from "react-i18next";






const AnnuairesList = () => {
  const { t } = useTranslation()

  return (
    <div>

      <div className="ttm-row sidebar ttm-bgcolor-grey ttm-sidebar-right clearfix" >
        <div className="container my-main mb-5">
          <div className="row ">
            <div className="col-lg-12">
              <div className="ttm-bg ttm-col-bgcolor-yes ">
                <div className="layer-content">
                  <div className="row">
                    <div className="container">
                      <div style={{ marginTop: 50 }}><h1 style={{ fontWeight: "bold", fontSize: 24 }}>{t("businessDirectory")}</h1></div>

                      <div className="row">

                        {GlobalData.user.activities.filter(activity => activity !== "other").map((activity, index) => (
                          <div className="col-md-4" key={index}>
                            <NavLink to={`/annuaire?activity=` + activity}>
                              <div className="categories_grid" style={{ marginLeft: 10, marginTop: 20 }}>
                                <img alt="" src={require("../assets/FrontOffice/images/" + GlobalData.user.activities_imgs[index])} style={{ height: 240, width: 360 }} className="img-fluid" />
                                <div className="wrapper">
                                  <p style={{ marginBottom: 10 }}>{t("user.activities." + activity)}</p>
                                </div>
                              </div>
                            </NavLink>
                          </div>
                        ))}


                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="ttm-row  clearfix" style={{ backgroundColor: "#f6b347" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center padding_bottom15">
                <h4 className="mt_10">{t('annuaire1.1')}</h4>
                <NavLink className="ttm-btn ttm-btn-size-md ttm-btn-shape-rounded ttm-btn-style-fill ttm-btn-color-skincolor margin_top15" to={"/inscription"}>{t('annuaire2.1')}</NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AnnuairesList;